import DrawerBlockComponent from "../../../../uiKit/Drawer/components/DrawerBlockComponent"
import { CheckboxFormItem, formItemLayoutBalanced, renderInputFormItem } from "../../_components/SettingFormItems"
import { Form, InputNumber } from "antd"
import * as React from "react"
import { SettingFormItem } from "../../types"
import { WrappedFormUtils } from "antd/lib/form/Form"
import { EditHoursOfOperationsRow } from "./EditHoursOfOperationsRow"
import { EditSourceRow } from "./EditSourceRow"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { InputOnOffCheckbox } from "./InputOnOffCheckbox"
import { MoFirstOrderDiscount } from "./MoFirstOrderDiscount"
import { Pricing } from "../../../../../graphql/types"

type Props = {
    moFirstOrderDiscountPricing: Maybe<Pricing>
    isDiscountEnabled: boolean
    isFirstTimeDiscountEnabled: boolean
    isAbilityToPayWithEgcEnabled: boolean
    discountValue: Maybe<number>
    firstTimeDiscountValue: Maybe<number>
    settings: SettingFormItem
    form: WrappedFormUtils
    onStateValueChanged: (stateKey: string, value: Maybe<any>) => void
    onChangeCallback: () => void
}

export const MobileGeneralSettings = (props: Props) => {
    return (
        <DrawerBlockComponent
            title="General Settings"
            style={{
                padding: 0,
            }}>
            <EditHoursOfOperationsRow hideTopBorder={true} onChangeCallback={props.onChangeCallback} />
            <EditSourceRow />
            {CheckboxFormItem(
                props.settings,
                "MIB_DO_NOT_MARK_AS_CLOSED_IF_CLOSED",
                "Do not mark as 'Closed' outside of Hours of Operation",
                props.form,
                null,
                props.onChangeCallback,
                "receipt-setting-form-item",
                "Recommended for catering, ticketing, and service-based businesses"
            )}
            {CheckboxFormItem(
                props.settings,
                "MIB_EMAIL_WITH_EVERY_ORDER",
                "Send Me an Email with Every New Online Order",
                props.form,
                null,
                props.onChangeCallback,
                "receipt-setting-form-item",
                "Emails to Customers are sent every time"
            )}
            {CheckboxFormItem(
                props.settings,
                "MIB_AUTO_ACCEPT_ALL",
                "Automatically Accept All Online Orders",
                props.form,
                null,
                props.onChangeCallback,
                "receipt-setting-form-item",
                null
            )}
            {props.form.getFieldValue("MIB_AUTO_ACCEPT_ALL")
                ? CheckboxFormItem(
                      props.settings,
                      "MIB_AUTO_ACCEPT_ONLY_WHEN_SIGNED_IN",
                      "Automatically Accept Online Orders only when Register is Signed In",
                      props.form,
                      {
                          marginLeft: "4rem",
                      },
                      props.onChangeCallback,
                      "receipt-setting-form-item",
                      null
                  )
                : null}
            {CheckboxFormItem(
                props.settings,
                "MIB_AUTO_CLOSE",
                "Automatically Close 'Paid Orders' upon Acceptance of Online Order",
                props.form,
                null,
                props.onChangeCallback,
                "receipt-setting-form-item",
                null
            )}
            {CheckboxFormItem(
                props.settings,
                "MIB_ABILITY_TO_DELAY_ORDERS_ENABLED",
                "Enable ability to 'delay orders' for 'Pick Up' and 'Delivery' orders",
                props.form,
                null,
                props.onChangeCallback,
                "receipt-setting-form-item",
                "Allows you to delay orders when your business is busy. This will also communicate the delay to your customers."
            )}
            <InputOnOffCheckbox
                settings={props.settings}
                key="MIB_PROMO_CODE_SP_ID"
                stateKey="isDiscountEnabled"
                stateFieldValue={props.isDiscountEnabled}
                label="Promo Discount"
                helperText="Set up Promo Discount (e.g -10%)"
                onChangeCallback={props.onChangeCallback}
                onStateValueChanged={props.onStateValueChanged}
                className="receipt-setting-form-item"
            />
            {props.isDiscountEnabled && (
                <>
                    <Form.Item
                        style={{
                            marginLeft: "3rem",
                            marginBottom: "0rem",
                            borderTop: "none",
                        }}
                        className="receipt-setting-form-item"
                        label="Promo Discount percentage"
                        {...formItemLayoutBalanced}>
                        <InputNumber
                            style={{
                                width: "12rem",
                                marginRight: 0,
                            }}
                            defaultValue={props.discountValue || undefined}
                            value={
                                (props.discountValue != null ? props.discountValue : props.discountValue) || undefined
                            }
                            formatter={value => `${value}%`}
                            onFocus={e => e.target.select()}
                            placeholder="-10%"
                            parser={value => (value || "").replace("%", "")}
                            onChange={val => {
                                props.onStateValueChanged("discountValue", -Math.abs(val ?? 0))
                                props.onChangeCallback()
                            }}
                        />
                    </Form.Item>
                    <div
                        style={{
                            marginBottom: "0.5rem",
                            marginLeft: "2rem",
                        }}>
                        {renderInputFormItem(
                            props.settings,
                            "MIB_PROMO_CODE_WORD",
                            "Promo Discount Code",
                            "Enter word",
                            props.form,
                            {},
                            props.onChangeCallback,
                            "receipt-setting-form-item promo-code-word",
                            "Please enter text required for customers to receive promotional discount",
                            false,
                            null,
                            {
                                width: "12rem",
                                textAlign: "left",
                                position: "relative",
                                top: "4px",
                            },
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: "Promo word cannot be empty",
                                    },
                                ],
                            }
                        )}
                    </div>
                </>
            )}
            <InputOnOffCheckbox
                settings={props.settings}
                key="MIB_ABILITY_TO_PAY_WITH_EGC"
                stateKey="isAbilityToPayWithEgcEnabled"
                stateFieldValue={props.isAbilityToPayWithEgcEnabled}
                label="Enable ability to pay with Gift Cards"
                onChangeCallback={props.onChangeCallback}
                onStateValueChanged={props.onStateValueChanged}
                className="receipt-setting-form-item"
            />
            <InputOnOffCheckbox
                settings={props.settings}
                key="MIB_FIRST_TIME_PROMO_DISCOUNT_SP_ID"
                stateKey="isFirstTimeDiscountEnabled"
                stateFieldValue={props.isFirstTimeDiscountEnabled}
                label="Enable discount for first time customers (customer must sign up new account)"
                helperText="Set up discount (e.g -10%)"
                onChangeCallback={props.onChangeCallback}
                onStateValueChanged={props.onStateValueChanged}
                className="receipt-setting-form-item"
            />
            {props.isFirstTimeDiscountEnabled && (
                <Form.Item
                    style={{
                        marginLeft: "3rem",
                        marginBottom: "1rem",
                        borderTop: "none",
                    }}
                    className="receipt-setting-form-item"
                    label="Discount percentage"
                    {...formItemLayoutBalanced}>
                    {/* @ts-expect-error */}
                    <InputNumber
                        style={{
                            width: "12rem",
                            marginRight: 0,
                        }}
                        defaultValue={props.firstTimeDiscountValue}
                        value={props.firstTimeDiscountValue}
                        formatter={value => `${value}%`}
                        onFocus={e => e.target.select()}
                        placeholder="-10%"
                        parser={value => (value || "").replace("%", "")}
                        onChange={(val: number) => {
                            props.onStateValueChanged("firstTimeDiscountValue", -Math.abs(val))
                            props.onChangeCallback()
                        }}
                    />
                </Form.Item>
            )}
            <MoFirstOrderDiscount
                form={props.form}
                enabled={!!props.settings.MO_FIRST_ORDER_PROMO_DISCOUNT_SP_ID.value}
                pricing={props.moFirstOrderDiscountPricing}
                onChange={props.onChangeCallback}
            />
        </DrawerBlockComponent>
    )
}
